import * as React from "react";
import { type FC } from "react";

import { AddressLevel } from "../../../../FiasInput/Types/FiasTypes";
import { AddressRow } from "../AddressRow";
import { Control } from "../controlsPaths";

interface CityProps {
    fullSizeAbbreviation: boolean;
    getValue: (control: Control) => string;
    onChange: (control: Control) => (next: string) => void;
}

const addressLevel = AddressLevel.Settlement;
const controlType = Control.CityType;
const controlName = Control.CityName;

export const City: FC<CityProps> = props => (
    <AddressRow
        caption={"Населенный пункт"}
        typePlaceholder={"Тип"}
        namePlaceholder={"Наименование"}
        typeTid={"CityType"}
        nameTid={"CityName"}
        fullSizeAbbreviation={props.fullSizeAbbreviation}
        controlType={controlType}
        level={addressLevel}
        type={props.getValue(controlType)}
        name={props.getValue(controlName)}
        onTypeChange={props.onChange(controlType)}
        onNameChange={props.onChange(controlName)}
    />
);
